import { motion } from 'motion/react'
import { SectionHeading } from '../common/SectionHeading'
import { hardware } from '../../utils/landingContent'
import type { LandingCopy } from '../../models/LandingPage'

type SupportedHardwareSectionProps = {
  copy: LandingCopy
  reveal: object
}

export function SupportedHardwareSection({ copy, reveal }: SupportedHardwareSectionProps) {
  return <section id="hardware" className="section hardware"><div className="container"><motion.div {...reveal}><SectionHeading eyebrow="05 — SUPPORTED HARDWARE" title={copy.hardwareTitle} sub={copy.hardwareSub}/></motion.div><div className="hardware-grid">{hardware.map(({ name, status, description },i)=><motion.article {...reveal} transition={{duration:.5,delay:(i%4)*.04}} key={name} className={status==='Beta'?'featured':''}><div className="hw-logo">{name.split(' ').map(x=>x[0]).join('').slice(0,2)}</div><div><h3>{name}</h3><p>{description}</p></div><span>{status}</span></motion.article>)}</div></div></section>
}
